// React
import { useState, useContext, useEffect } from 'react';

// Pdf.js
import * as pdfjsLib from 'pdfjs-dist';

// Global Context
import { GlobalContext } from '../../../contexts/Global';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/5.4.54/pdf.worker.min.mjs`;

const Thumbnail = ({ file }) => {
    const [ thumbnailUrl, setThumbnailUrl ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const { user } = useContext(GlobalContext);

    useEffect(() => {
        const loadImageWithAuth = async (url) => {
            try {
                const response = await fetch(url, {
                    headers: {
                        'Authorization': 'Bearer ' + user.access_token
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch image: ${response.status}`);
                }

                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                setThumbnailUrl(objectUrl);
            }
            catch (error) {
                console.error('Error loading image with auth:', error);
            }
            finally {
                setLoading(false);
            }
        };

        const generatePdfThumbnail = async (file) => {
            const fileUrl = URL.createObjectURL(file);
            let canvas, context;

            try {
                const pdf = await pdfjsLib.getDocument(fileUrl).promise;
                const page = await pdf.getPage(1);
                const viewport = page.getViewport({ scale: 0.5 });

                canvas = document.createElement('canvas');
                context = canvas.getContext('2d');

                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({ canvasContext: context, viewport }).promise;

                setThumbnailUrl(canvas.toDataURL());
            }
            catch (error) {
                console.error('Error generating PDF thumbnail:', error);
            }
            finally {
                URL.revokeObjectURL(fileUrl);
                setLoading(false);
            }
        };

        setThumbnailUrl(null);
        setLoading(true);

        if (file instanceof File && file.type === 'application/pdf') {
            generatePdfThumbnail(file);
        }
        else if (file instanceof File) {
            const objectUrl = URL.createObjectURL(file);
            setThumbnailUrl(objectUrl);
            setLoading(false);
        }
        else if (file && file.url) {
            if (user && user.access_token) {
                loadImageWithAuth(file.url);
            }
            else {
                setThumbnailUrl(file.url);
                setLoading(false);
            }
        }
        else {
            setLoading(false);
        }

        return () => {
            if (thumbnailUrl && thumbnailUrl.startsWith('blob:')) {
                URL.revokeObjectURL(thumbnailUrl);
            }
        };
    }, [ file, user?.access_token ]);

    useEffect(() => {
        return () => {
            if (thumbnailUrl && thumbnailUrl.startsWith('blob:')) {
                URL.revokeObjectURL(thumbnailUrl);
            }
        };
    }, [ thumbnailUrl ]);

    if (loading) {
        return <div className="loading">Generazione anteprima...</div>;
    }

    if (thumbnailUrl) {
        return <img alt="" src={ thumbnailUrl } />;
    }

    if (file instanceof File && file.type === 'application/pdf') {
        return <div className="loading">Anteprima PDF non disponibile</div>;
    }

    return <div className="loading">Anteprima non disponibile</div>;
};

export default Thumbnail;
